import { createRoot } from 'react-dom/client'
import App from './App'
import { store, persistor } from './app/store'
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import './index.css'
import Quill from 'quill';
import './utils/i18n/i18n.ts';

Quill.debug('error');

//elimina el warning del findDom, tendremos que cambiar tarde o temprano el codigo
const originalConsoleError = console.error;
console.error = (message, ...args) => {
  if (typeof message === 'string' && message.includes('findDOMNode')) {
    return; 
  }
  originalConsoleError(message, ...args);
};

createRoot(document.getElementById('root')!).render(
  
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>

)
